import {Action, createAction} from '@ngrx/store';

export enum NavigationActions {
  LEFT_NAVIGATION_UPDATE = '[INavigationModel] UpdateLeftNav',
  RIGHT_NAVIGATION_UPDATE = '[INavigationModel] UpdateRightNav',
  RIGHT_NAVIGATION_CLOSE = '[INavigationModel] CloseRightNav',
  LEFT_NAVIGATION_CLOSE = '[INavigationModel] CloseLeftNav'

}

export const leftNavigationUpdateAction = createAction(
  NavigationActions.LEFT_NAVIGATION_UPDATE
);

export const rightNavigationUpdateAction = createAction(
  NavigationActions.RIGHT_NAVIGATION_UPDATE
);

export const rightNavigationCloseAction = createAction(
  NavigationActions.RIGHT_NAVIGATION_CLOSE
);

export const leftNavigationCloseAction = createAction(
  NavigationActions.LEFT_NAVIGATION_CLOSE
);
